<rask-textarea
    label="Kommentar"
    [rows]="5"
    [maxlength]="250"
    infoText="Beskriv anledningen för returnering, ärendenummer eller annan viktig information att skicka med till GISS..."
    placeholder="Beskriv anledningen för returnering, ärendenummer eller annan viktig information att skicka med till GISS..."
    class="return-giss-textarea w-100"
    [(ngModel)]="_data">
</rask-textarea>

<div class="return-giss-modal-footer">
    <rask-button
        color="primary"
        (click)="returnera()"
        [disabled]="!_data">
        Returnera
    </rask-button>
    <rask-button color="secondary" (click)="cancel()">
        {{ 'DEFAULT_BUTTON_LABEL_AVBRYT' | translate }}
    </rask-button>
</div>
